<template>
  <div class="about-smallest-ring">
    <div class="smallest-ring-carousel">
      <about-team-image-carousel
        v-bind:images="smallestRingImages"
      ></about-team-image-carousel>
    </div>
    <div class="smallest-ring-description">
      <div class="text-block">
        <h3>Самое маленькое кольцо с бриллиантом</h3>
        <p>
          Вадим с детства любил создавать маленькие вещи. Будучи ребенком,
          он мастерил ножики из тонкой алюминиевой проволоки, клеил книжки
          размером 1 см и т.д.
          <q
            cite="https://www.belta.by/regions/view/reportazh-juvelir-iz-bresta-sozdal-samoe-malenkoe-koltso-v-mire-377219-2020/"
          >Это было увлечение, которое, наверное, отчасти меня к ювелирному
          делу и привело</q>, – говорит мастер.
        </p>
        <p>
          Вадим утверждает, что создать миниатюрное кольцо без камня
          несложно.
        </p>
        <blockquote cite="https://jewellerycut.com/is-this-the-smallest-diamond-ring-in-the-world/">
          Гораздо сложнее подготовить оправу для камня.
          Самая трудная часть работы состояла в том, чтобы припаять оправу из
          белого золота к кольцу из желтого золота, поскольку разнородные
          материалы гораздо более трудно поддаются спайке.
        </blockquote>
      </div>
    </div>
    <div class="video-section">
      <video-centered
        v-bind:video-id="smallestRingYouTubeId"
      ></video-centered>
    </div>
  </div>
</template>

<script>
import AboutTeamImageCarousel from './about-team/AboutTeamImageCarousel'
import VideoCentered from './utils/VideoCentered'

export default {
  name: 'AboutTeamVadimSmallestRing',
  props: ['smallest-ring-images'],
  components: {AboutTeamImageCarousel, VideoCentered},
  data: function () {
    return {
      smallestRingYouTubeId: 'Vg0UQRLccGw'
    }
  }
}
</script>

<style scoped lang="scss">
  .about-smallest-ring {
    & > .smallest-ring-carousel {
      background-color: #eee;
      @include page-block-vertical-padding();
      & >>> .carousel .slick-dots li button:before {
        color: $default-background-color;
      }
      & >>> .slick-prev:before,
      & >>> .slick-next:before {
        color: $default-background-color;
      }
    }
    & > .smallest-ring-description {
      background-color: $inverse-background-color;
      color: $inverse-text-color;
      @include page-block-vertical-padding();
      h3 {
        color: $inverse-text-color;
        padding: 0.5em 0;
      }
      blockquote, q {
        font-weight: bold;
      }
      blockquote {
        text-align: justify;
        font-family: "Cormorant Light", $font-stack;
        quotes: "\201C""\201D""\2018""\2019";

        position: relative;
        border-top: 1px solid $default-link-color;
        border-bottom: 1px solid $default-link-color;
        @include media (">desktop") {
          padding: 1.25em 2em;
          margin: 1.5em 2em 0 2em;
        };
        @include media (">tablet", "<=desktop") {
          margin: 1.5em 1em 0 1em;
          padding: 1.25em 1.5em;
        };
        @include media ("<=tablet") {
          margin: 1.5em 0 0 0;
          padding: 1.25em 1em;
        };

        .wf-cormorantlight-n4-active & { font-size: 1.25em; }
        &:before {
          content: open-quote;
          font-family: serif, $font-stack;
          font-size: 2em;
          color: $default-text-color;
          background-color: $inverse-background-color;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%, -0.5em);
          padding: 0 0.5em;
        }
      }
    }
    & > .video-section {
      background-color: $content-background-color;
      @include page-block-vertical-padding();
    }
    .text-block {
      @include text-block();
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/AboutTeamVadimSmallestRing.vue